export default __webpack_public_path__ + "static/media/ICONOS INGLÉS  MI SEGURO SOMIT -05.0aa75e20.png";